import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { NgStyle } from '@angular/common';
import { LandingConfigDto } from '@campaigns/data-access';

@Component({
  selector: 'campaign-landing-status-card',
  imports: [NgStyle],
  templateUrl: './landing-status-card.component.html',
  styleUrl: './landing-status-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingStatusCardComponent {
  readonly config = input.required<LandingConfigDto>();
  readonly title = input.required<string>();
  readonly text = input<string>('');
  readonly icon = input<string>('info-circle-fill');
  readonly loading = input<boolean>(false);
  readonly actionText = input<string | null>(null);
  readonly action = output<void>();

  protected readonly cardStyle = computed(() => ({
    'background-color': this.config().typography.formBackgroundColor,
  }));

  protected readonly accentStyle = computed(() => ({
    color: this.config().typography.primaryColor,
  }));

  protected readonly titleStyle = computed(() => ({
    color: this.config().typography.textColor,
  }));

  protected readonly textStyle = computed(() => ({
    color: this.config().typography.labelColor,
  }));

  protected readonly buttonStyle = computed(() => ({
    'background-color': this.config().typography.primaryColor,
    color: this.config().typography.buttonTextColor,
  }));
}
